import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, name = '') {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                name
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: 0,
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(region => {
                let telem = {
                    tbody: {}
                };
                telem.id = region.id;
                telem.tbody.code = region.code;
                telem.tbody.name = region.name;
                result.tbody.push(telem);
            });

            result.pages = response.pages;
        }
        return result;
    }
}
